// https://vuex.vuejs.org/en/getters.html

export default {
  locations(state) {
    return state.locations;
  },
  errors(state) {
    return state.errors;
  },
  loading(state) {
    return state.loading;
  },
  totalCount(state) {
    return state.totalCount;
  },
};
